import React from "react";
import { NavLink, Outlet, Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { LogOut, Package, MapPin, User as UserIcon, Heart } from "lucide-react";

const TABS = [
  { to: "/account", label: "Overview", icon: UserIcon, end: true },
  { to: "/account/orders", label: "Orders", icon: Package },
  { to: "/account/addresses", label: "Addresses", icon: MapPin },
  { to: "/account/profile", label: "Profile", icon: UserIcon },
  { to: "/wishlist", label: "Wishlist", icon: Heart },
];

export default function AccountLayout() {
  const { user, loading, logout } = useAuth();
  if (loading) return <div className="min-h-[60vh] flex items-center justify-center text-white/60">Loading…</div>;
  if (!user) return <Navigate to="/signin" replace state={{ from: "/account" }} />;

  return (
    <div data-testid="account-layout" className="min-h-screen max-w-7xl mx-auto px-6 lg:px-10 py-12 lg:py-16">
      <div className="overline mb-2">Account</div>
      <h1 className="font-display text-4xl sm:text-5xl uppercase tracking-tight">Hey, {user.name?.split(" ")[0] || "Rider"}</h1>
      <p className="text-white/55 font-body mt-2">{user.email}</p>

      <div className="grid lg:grid-cols-12 gap-10 mt-12">
        <aside className="lg:col-span-3">
          <ul className="space-y-1 border border-white/10">
            {TABS.map((t) => (
              <li key={t.to}>
                <NavLink
                  to={t.to}
                  end={t.end}
                  data-testid={`account-tab-${t.label.toLowerCase()}`}
                  className={({ isActive }) =>
                    `flex items-center gap-3 px-4 py-3 font-display text-sm tracking-widest uppercase transition-colors ${
                      isActive ? "bg-[#D96A1B] text-white" : "text-white/70 hover:bg-white/5 hover:text-white"
                    }`
                  }
                >
                  <t.icon size={16} /> {t.label}
                </NavLink>
              </li>
            ))}
            <li>
              <button
                data-testid="account-logout"
                onClick={logout}
                className="w-full flex items-center gap-3 px-4 py-3 font-display text-sm tracking-widest uppercase text-white/70 hover:bg-white/5 hover:text-[#D96A1B] border-t border-white/10"
              >
                <LogOut size={16} /> Logout
              </button>
            </li>
          </ul>
        </aside>
        <main className="lg:col-span-9">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
